const propertyUseCategories: { code: string; label: string; family: string }[] = [
	{ code: "10", label: "Logement", family: "1 – Résidentielle" },
	{ code: "11", label: "Chalet ou maison de villégiature", family: "1 – Résidentielle" },
	{ code: "12", label: "Maison mobile, roulotte", family: "1 – Résidentielle" },
	{ code: "15", label: "Habitation en commun", family: "1 – Résidentielle" },
	{ code: "151", label: "Maison de chambres et pension", family: "1 – Résidentielle" },
	{ code: "152", label: "Habitation pour groupes organisés", family: "1 – Résidentielle" },
	{ code: "153", label: "Résidence et maison d'étudiants", family: "1 – Résidentielle" },
	{ code: "154", label: "Maison de retraite et orphelinat", family: "1 – Résidentielle" },
	{ code: "155", label: "Maison d'institutions religieuses", family: "1 – Résidentielle" },
	{ code: "159", label: "Autres habitations de groupes", family: "1 – Résidentielle" },
	{ code: "16", label: "Hôtel et motel résidentiel", family: "1 – Résidentielle" },
	{ code: "160", label: "Hôtel résidentiel", family: "1 – Résidentielle" },
	{ code: "161", label: "Motel résidentiel", family: "1 – Résidentielle" },
	{ code: "17", label: "Parc de roulottes et de maisons mobiles", family: "1 – Résidentielle" },
	{ code: "18", label: "Résidence provisoire", family: "1 – Résidentielle" },
	{ code: "189", label: "Autres résidences provisoires", family: "1 – Résidentielle" },
	{ code: "19", label: "Autres immeubles résidentiels", family: "1 – Résidentielle" },
	{ code: "191", label: "Habitation pour la chasse, la pêche et la forêt", family: "1 – Résidentielle" },
	{ code: "192", label: "Espace détenu en copropriété divise résidentielle", family: "1 – Résidentielle" },
	{ code: "20", label: "Industrie d'aliments et de boissons", family: "2-3 – Industries manufacturières" },
	{
		code: "201",
		label: "Industrie de l'abattage et de la transformation d'animaux",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "202",
		label: "Industrie de la préparation et du conditionnement de poissons et de fruits de mer",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "203",
		label: "Industrie de la mise en conserve de fruits et de légumes et fabrication de spécialités alimentaires",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "204", label: "Industrie de produits laitiers", family: "2-3 – Industries manufacturières" },
	{
		code: "205",
		label: "Industrie de la farine et de céréales de table préparées",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "206", label: "Industrie d'aliments pour animaux", family: "2-3 – Industries manufacturières" },
	{
		code: "207",
		label: "Industrie de produits de boulangerie, du pain et de pâtisseries",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "208", label: "Industrie d'autres produits alimentaires", family: "2-3 – Industries manufacturières" },
	{ code: "209", label: "Industrie de boissons", family: "2-3 – Industries manufacturières" },
	{ code: "21", label: "Industrie du tabac et du cannabis", family: "2-3 – Industries manufacturières" },
	{ code: "211", label: "Industrie du tabac", family: "2-3 – Industries manufacturières" },
	{ code: "212", label: "Industrie des produits du tabac", family: "2-3 – Industries manufacturières" },
	{ code: "213", label: "Industrie du cannabis", family: "2-3 – Industries manufacturières" },
	{
		code: "22",
		label: "Industrie de produits en caoutchouc et en plastique",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "221", label: "Industrie de produits en caoutchouc", family: "2-3 – Industries manufacturières" },
	{
		code: "222",
		label: "Industrie de produits en mousse de polystyrène, d'uréthane et en d'autres plastiques",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "223",
		label: "Industrie de la tuyauterie, de pellicules et de feuilles en plastique",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "224",
		label: "Industrie de produits en plastique stratifié, sous pression ou renforcé",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "225",
		label: "Industrie de produits d'architecture en plastique",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "226",
		label: "Industrie de contenants en plastique (sauf en mousse)",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "227", label: "Industrie de portes et de fenêtres en plastique", family: "2-3 – Industries manufacturières" },
	{ code: "229", label: "Autres industries de produits en plastique", family: "2-3 – Industries manufacturières" },
	{ code: "23", label: "Industrie du cuir et de produits connexes", family: "2-3 – Industries manufacturières" },
	{ code: "231", label: "Tannerie", family: "2-3 – Industries manufacturières" },
	{ code: "232", label: "Industrie de la chaussure", family: "2-3 – Industries manufacturières" },
	{
		code: "234",
		label: "Industrie de valises, bourses et sacs à main et menus articles en cuir",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "239",
		label: "Autres industries du cuir et de produits connexes",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "24", label: "Industrie textile", family: "2-3 – Industries manufacturières" },
	{ code: "241", label: "Industrie de filés et de tissus tissés (coton)", family: "2-3 – Industries manufacturières" },
	{ code: "242", label: "Industrie de filés et de tissus tissés (laine)", family: "2-3 – Industries manufacturières" },
	{
		code: "243",
		label: "Industrie de fibres, de filés et de tissus tissés (fibres synthétiques et filés de filament)",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "244", label: "Industrie de la corde et de la ficelle", family: "2-3 – Industries manufacturières" },
	{
		code: "245",
		label: "Industrie du feutre et du traitement de fibres naturelles",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "246", label: "Industrie de tapis, carpettes et moquettes", family: "2-3 – Industries manufacturières" },
	{ code: "247", label: "Industrie d'articles en grosse toile", family: "2-3 – Industries manufacturières" },
	{ code: "249", label: "Autres industries de produits textiles", family: "2-3 – Industries manufacturières" },
	{ code: "25", label: "Incubateur industriel", family: "2-3 – Industries manufacturières" },
	{ code: "26", label: "Industrie vestimentaire", family: "2-3 – Industries manufacturières" },
	{
		code: "261",
		label: "Industrie de vêtements coupés-cousus pour hommes et garçons",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "262",
		label: "Industrie de vêtements coupés-cousus pour femmes et filles",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "263",
		label: "Industrie de vêtements coupés-cousus pour enfants et bébés",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "264", label: "Industrie de vêtements en fourrure et en cuir", family: "2-3 – Industries manufacturières" },
	{ code: "265", label: "Industrie de tricotage de vêtements", family: "2-3 – Industries manufacturières" },
	{ code: "269", label: "Autres industries vestimentaires", family: "2-3 – Industries manufacturières" },
	{ code: "27", label: "Industrie du bois", family: "2-3 – Industries manufacturières" },
	{ code: "271", label: "Industrie du bois de sciage et du bardeau", family: "2-3 – Industries manufacturières" },
	{
		code: "272",
		label: "Industrie de placages, de contreplaqués et de produits en bois reconstitué",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "273", label: "Industrie de menuiseries préfabriquées", family: "2-3 – Industries manufacturières" },
	{
		code: "274",
		label: "Industrie de contenants en bois et de palettes en bois",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "275", label: "Industrie du cercueil en bois ou en métal", family: "2-3 – Industries manufacturières" },
	{ code: "279", label: "Autres industries du bois", family: "2-3 – Industries manufacturières" },
	{ code: "28", label: "Industrie du meuble et d'articles d'ameublement", family: "2-3 – Industries manufacturières" },
	{ code: "281", label: "Industrie du meuble résidentiel", family: "2-3 – Industries manufacturières" },
	{ code: "282", label: "Industrie du meuble de bureau", family: "2-3 – Industries manufacturières" },
	{
		code: "289",
		label: "Autres industries du meuble et d'articles d'ameublement",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "29", label: "Industrie du papier et de produits du papier", family: "2-3 – Industries manufacturières" },
	{
		code: "291",
		label: "Industrie de pâte à papier, de papier et de produits du papier",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "292", label: "Industrie du papier asphalté pour couvertures", family: "2-3 – Industries manufacturières" },
	{
		code: "293",
		label: "Industrie de contenants en carton et de sacs en papier",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "299",
		label: "Autres industries de fabrication de produits en papier transformé (fabriqué à partir de papier acheté)",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "30", label: "Imprimerie, édition et industries connexes", family: "2-3 – Industries manufacturières" },
	{ code: "301", label: "Industrie de l'impression commerciale", family: "2-3 – Industries manufacturières" },
	{
		code: "302",
		label: "Industrie du clichage, de la composition, de la reliure et de la lithographie",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "303", label: "Industrie de l'édition", family: "2-3 – Industries manufacturières" },
	{
		code: "304",
		label: "Industrie de l'impression et de l'édition (combinées)",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "305", label: "Industrie du logiciel ou progiciel", family: "2-3 – Industries manufacturières" },
	{ code: "31", label: "Industrie de première transformation de métaux", family: "2-3 – Industries manufacturières" },
	{ code: "311", label: "Industrie sidérurgique", family: "2-3 – Industries manufacturières" },
	{
		code: "312",
		label: "Industrie de tubes et de tuyaux en fer et en acier à partir d'acier acheté",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "314", label: "Fonderie de métaux ferreux", family: "2-3 – Industries manufacturières" },
	{
		code: "315",
		label: "Industrie de la production et de la transformation de métaux non ferreux (sauf l'aluminium)",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "316",
		label: "Industrie de la production et de la transformation d'alumine et d'aluminium",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "317",
		label: "Industrie du laminage, de l'étirage et de l'extrusion du cuivre et de ses alliages",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "318", label: "Fonderie de métaux non ferreux", family: "2-3 – Industries manufacturières" },
	{
		code: "32",
		label: "Industrie de produits métalliques (sauf les industries de la machinerie et du matériel de transport)",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "321",
		label: "Industrie de chaudières, d'échangeurs de chaleur et de plaques métalliques",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "322", label: "Industrie de produits de construction en métal", family: "2-3 – Industries manufacturières" },
	{
		code: "323",
		label: "Industrie de produits métalliques d'ornement et d'architecture",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "324",
		label: "Industrie de l'emboutissage, du matriçage et du revêtement métallique",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "325", label: "Industrie du fil métallique et de ses dérivés", family: "2-3 – Industries manufacturières" },
	{
		code: "326",
		label: "Industrie d'articles de quincaillerie, d'outillage et de coutellerie",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "327",
		label: "Industrie du matériel de chauffage et du matériel de réfrigération commerciale",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "328", label: "Industrie d'usinage", family: "2-3 – Industries manufacturières" },
	{
		code: "329",
		label: "Autres industries de produits métalliques divers",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "33", label: "Industrie de la machinerie (sauf électrique)", family: "2-3 – Industries manufacturières" },
	{ code: "331", label: "Industrie de machines agricoles", family: "2-3 – Industries manufacturières" },
	{
		code: "332",
		label: "Industrie de machines-outils pour le travail du métal",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "333",
		label: "Industrie d'appareils de ventilation et de climatisation",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "334",
		label: "Industrie de la machinerie pour l'industrie du caoutchouc et du plastique",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "335",
		label: "Industrie de la machinerie pour le commerce et les industries de services",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "339",
		label: "Autres industries de la machinerie et de l'équipement",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "34", label: "Industrie du matériel de transport", family: "2-3 – Industries manufacturières" },
	{ code: "341", label: "Industrie d'aéronefs et de pièces d'aéronefs", family: "2-3 – Industries manufacturières" },
	{ code: "343", label: "Industrie de véhicules automobiles", family: "2-3 – Industries manufacturières" },
	{
		code: "344",
		label: "Industrie de carrosseries de camions, d'autobus et de remorques",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "345",
		label: "Industrie de pièces et d'accessoires pour véhicules automobiles",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "346", label: "Industrie du matériel ferroviaire roulant", family: "2-3 – Industries manufacturières" },
	{
		code: "347",
		label: "Industrie de la construction et de la réparation de navires",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "348",
		label: "Industrie de la construction et de la réparation d'embarcations",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "349", label: "Autres industries du matériel de transport", family: "2-3 – Industries manufacturières" },
	{
		code: "35",
		label: "Industrie de produits électriques et électroniques et de production privée d'électricité",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "351", label: "Industrie de petits appareils électroménagers", family: "2-3 – Industries manufacturières" },
	{ code: "352", label: "Industrie de gros appareils", family: "2-3 – Industries manufacturières" },
	{ code: "353", label: "Industrie d'appareils d'éclairage", family: "2-3 – Industries manufacturières" },
	{ code: "354", label: "Industrie du matériel électronique ménager", family: "2-3 – Industries manufacturières" },
	{
		code: "355",
		label: "Industrie du matériel électronique professionnel",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "356",
		label: "Industrie du matériel électrique d'usage industriel",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "357",
		label: "Industrie de machines pour bureaux, magasins, commerces et usage personnel",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "358", label: "Industrie de fils et de câbles électriques", family: "2-3 – Industries manufacturières" },
	{
		code: "359",
		label: "Autres industries de produits électriques et de production privée d'électricité",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "36", label: "Industrie de produits minéraux non métalliques", family: "2-3 – Industries manufacturières" },
	{
		code: "361",
		label: "Industrie de produits en argile et de produits réfractaires",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "362", label: "Industrie du ciment", family: "2-3 – Industries manufacturières" },
	{ code: "363", label: "Industrie de produits en pierre", family: "2-3 – Industries manufacturières" },
	{ code: "364", label: "Industrie de produits en béton", family: "2-3 – Industries manufacturières" },
	{ code: "365", label: "Industrie du béton préparé", family: "2-3 – Industries manufacturières" },
	{ code: "366", label: "Industrie du verre et de produits en verre", family: "2-3 – Industries manufacturières" },
	{ code: "367", label: "Industrie de produits abrasifs", family: "2-3 – Industries manufacturières" },
	{ code: "368", label: "Industrie de la chaux", family: "2-3 – Industries manufacturières" },
	{
		code: "369",
		label: "Autres industries de produits minéraux non métalliques",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "37", label: "Industrie de produits du pétrole et du charbon", family: "2-3 – Industries manufacturières" },
	{ code: "371", label: "Industrie de produits raffinés du pétrole", family: "2-3 – Industries manufacturières" },
	{
		code: "379",
		label: "Autres industries de produits du pétrole et du charbon",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "38", label: "Industrie chimique", family: "2-3 – Industries manufacturières" },
	{
		code: "382",
		label: "Industrie de produits chimiques d'usage agricole",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "383",
		label: "Industrie du plastique et de résines synthétiques",
		family: "2-3 – Industries manufacturières",
	},
	{
		code: "384",
		label: "Industrie de produits pharmaceutiques et de médicaments",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "385", label: "Industrie de peinture, de teinture et de vernis", family: "2-3 – Industries manufacturières" },
	{
		code: "386",
		label: "Industrie de savons et de détachants pour le nettoyage",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "387", label: "Industrie de produits de toilette", family: "2-3 – Industries manufacturières" },
	{
		code: "388",
		label: "Industrie de produits chimiques d'usage industriel",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "389", label: "Autres industries de produits chimiques", family: "2-3 – Industries manufacturières" },
	{ code: "39", label: "Autres industries manufacturières", family: "2-3 – Industries manufacturières" },
	{
		code: "391",
		label: "Industrie du matériel scientifique et professionnel",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "392", label: "Industrie de la bijouterie et de l'orfèvrerie", family: "2-3 – Industries manufacturières" },
	{ code: "393", label: "Industrie d'articles de sport et de jouets", family: "2-3 – Industries manufacturières" },
	{ code: "394", label: "Industrie de stores vénitiens", family: "2-3 – Industries manufacturières" },
	{
		code: "397",
		label: "Industrie d'enseignes, d'étalages et de tableaux d'affichage",
		family: "2-3 – Industries manufacturières",
	},
	{ code: "399", label: "Autres industries de produits manufacturés", family: "2-3 – Industries manufacturières" },
	{ code: "41", label: "Chemin de fer et métro", family: "4 – Transports, communications et services publics" },
	{
		code: "411",
		label: "Transport par chemin de fer (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "412", label: "Métro", family: "4 – Transports, communications et services publics" },
	{
		code: "42",
		label: "Transport par véhicule moteur (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "421",
		label: "Transport par autobus (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "422",
		label: "Transport de matériel par camion (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "429",
		label: "Autres transports par véhicule automobile (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "43",
		label: "Transport aérien (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "431", label: "Aéroport", family: "4 – Transports, communications et services publics" },
	{
		code: "439",
		label: "Autres transports aériens (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "44",
		label: "Transport maritime (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "441", label: "Installation portuaire", family: "4 – Transports, communications et services publics" },
	{
		code: "449",
		label: "Autres transports maritimes (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "45", label: "Voie publique", family: "4 – Transports, communications et services publics" },
	{ code: "451", label: "Autoroute", family: "4 – Transports, communications et services publics" },
	{ code: "452", label: "Boulevard", family: "4 – Transports, communications et services publics" },
	{ code: "453", label: "Artère principale", family: "4 – Transports, communications et services publics" },
	{ code: "454", label: "Artère secondaire", family: "4 – Transports, communications et services publics" },
	{
		code: "455",
		label: "Rue et avenue pour l'accès local",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "456", label: "Ruelle et passage", family: "4 – Transports, communications et services publics" },
	{
		code: "459",
		label: "Autres routes et voies publiques",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "46",
		label: "Terrain et garage de stationnement pour véhicules",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "461",
		label: "Garage de stationnement pour automobiles (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "462",
		label: "Terrain de stationnement pour automobiles et assiette d'autoroute",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "463",
		label: "Espace détenu en copropriété divise non résidentielle",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "47",
		label: "Industrie de l'information et industrie culturelle",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "471",
		label: "Télécommunications, centre et réseau téléphonique",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "472",
		label: "Communication, centre et réseau télégraphique",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "473",
		label: "Communication, diffusion radiophonique",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "474",
		label: "Communication, centre et réseau de télédiffusion (câblodistribution)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "475",
		label: "Centre et réseau de radiodiffusion et de télédiffusion (système combiné)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "476",
		label: "Industrie de l'enregistrement sonore (disque, cassette et disque compact)",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "477", label: "Industrie du film et du vidéo", family: "4 – Transports, communications et services publics" },
	{
		code: "478",
		label: "Services de traitement des données, d'hébergement des données et services connexes",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "479", label: "Autres services d'information", family: "4 – Transports, communications et services publics" },
	{
		code: "48",
		label: "Service public (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "481",
		label: "Production d'énergie (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "482",
		label: "Transport et distribution d'énergie",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "483", label: "Aqueduc et irrigation", family: "4 – Transports, communications et services publics" },
	{ code: "484", label: "Égout (infrastructure)", family: "4 – Transports, communications et services publics" },
	{
		code: "485",
		label: "Dépotoir et installation inhérente aux ordures",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "487",
		label: "Récupération et triage de produits divers",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "488", label: "Dépôt à neige", family: "4 – Transports, communications et services publics" },
	{
		code: "489",
		label: "Autres services publics (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "49",
		label: "Autres transports, communications et services publics (infrastructure)",
		family: "4 – Transports, communications et services publics",
	},
	{
		code: "492",
		label: "Service et aménagement pour le transport",
		family: "4 – Transports, communications et services publics",
	},
	{ code: "50", label: "Centre commercial et immeuble commercial", family: "5 – Commerciale" },
	{ code: "500", label: "Centre commercial", family: "5 – Commerciale" },
	{ code: "501", label: "Immeuble commercial", family: "5 – Commerciale" },
	{ code: "502", label: "Entreposage pour usage commercial", family: "5 – Commerciale" },
	{ code: "503", label: "Entreprise de télémagasinage et de vente par correspondance", family: "5 – Commerciale" },
	{ code: "51", label: "Vente en gros", family: "5 – Commerciale" },
	{ code: "511", label: "Vente en gros d'automobiles, de pièces et d'accessoires", family: "5 – Commerciale" },
	{
		code: "512",
		label: "Vente en gros de médicaments, de produits chimiques et de produits connexes",
		family: "5 – Commerciale",
	},
	{ code: "513", label: "Vente en gros de vêtements et de tissus", family: "5 – Commerciale" },
	{ code: "514", label: "Vente en gros, épicerie et produits connexes", family: "5 – Commerciale" },
	{ code: "515", label: "Vente en gros de produits de la ferme (produits bruts)", family: "5 – Commerciale" },
	{ code: "516", label: "Vente en gros de matériel électrique et électronique", family: "5 – Commerciale" },
	{
		code: "517",
		label: "Vente en gros de quincaillerie, d'équipements de plomberie et de chauffage, incluant les pièces",
		family: "5 – Commerciale",
	},
	{ code: "518", label: "Vente en gros d'équipements et de pièces de machinerie", family: "5 – Commerciale" },
	{ code: "519", label: "Autres activités de vente en gros", family: "5 – Commerciale" },
	{ code: "52", label: "Vente au détail de produits de construction et de quincaillerie", family: "5 – Commerciale" },
	{ code: "521", label: "Vente au détail de matériaux de construction et de bois", family: "5 – Commerciale" },
	{
		code: "522",
		label: "Vente au détail d'équipements de plomberie, de chauffage, de ventilation, de climatisation et de foyer",
		family: "5 – Commerciale",
	},
	{ code: "523", label: "Vente au détail de peinture, de verre et de papier de tenture", family: "5 – Commerciale" },
	{ code: "524", label: "Vente au détail de matériel électrique et d'éclairage", family: "5 – Commerciale" },
	{ code: "525", label: "Vente au détail de quincaillerie et d'équipements de ferme", family: "5 – Commerciale" },
	{ code: "526", label: "Vente au détail de maisons et de chalets préfabriqués", family: "5 – Commerciale" },
	{ code: "527", label: "Vente au détail de produits du béton", family: "5 – Commerciale" },
	{ code: "53", label: "Vente au détail de marchandises en général", family: "5 – Commerciale" },
	{ code: "531", label: "Vente au détail, magasin à rayons", family: "5 – Commerciale" },
	{ code: "532", label: "Vente au détail, clubs de gros et hypermarchés", family: "5 – Commerciale" },
	{
		code: "533",
		label: "Vente au détail, variété de marchandises à prix d’escompte et marchandises d'occasion",
		family: "5 – Commerciale",
	},
	{ code: "534", label: "Vente au détail, machine distributrice", family: "5 – Commerciale" },
	{
		code: "536",
		label: "Vente au détail de matériel motorisé, d'articles, d'accessoires d'aménagement paysager et de jardin",
		family: "5 – Commerciale",
	},
	{ code: "537", label: "Vente au détail de piscines et leurs accessoires", family: "5 – Commerciale" },
	{ code: "539", label: "Vente au détail d'autres marchandises en général", family: "5 – Commerciale" },
	{ code: "54", label: "Vente au détail de produits de l'alimentation", family: "5 – Commerciale" },
	{ code: "541", label: "Vente au détail de produits d'épicerie (avec ou sans boucherie)", family: "5 – Commerciale" },
	{ code: "542", label: "Vente au détail de la viande et du poisson", family: "5 – Commerciale" },
	{ code: "543", label: "Vente au détail de fruits, de légumes et marché public", family: "5 – Commerciale" },
	{ code: "544", label: "Vente au détail de bonbons, d'amandes et de confiseries", family: "5 – Commerciale" },
	{ code: "545", label: "Vente au détail de produits laitiers", family: "5 – Commerciale" },
	{
		code: "546",
		label: "Vente au détail de produits de la boulangerie et de la pâtisserie",
		family: "5 – Commerciale",
	},
	{ code: "547", label: "Vente au détail de produits naturels", family: "5 – Commerciale" },
	{
		code: "549",
		label: "Autres activités de vente au détail de produits de l'alimentation",
		family: "5 – Commerciale",
	},
	{ code: "55", label: "Vente au détail de véhicules et de produits connexes", family: "5 – Commerciale" },
	{ code: "551", label: "Vente au détail de véhicules à moteur", family: "5 – Commerciale" },
	{
		code: "552",
		label: "Vente au détail de pièces de véhicules automobiles, de pneus, de batteries et d’accessoires",
		family: "5 – Commerciale",
	},
	{ code: "553", label: "Station-service", family: "5 – Commerciale" },
	{
		code: "559",
		label: "Autres activités de vente au détail d'automobiles, d'embarcations, d'avions et d'accessoires",
		family: "5 – Commerciale",
	},
	{ code: "56", label: "Vente au détail de vêtements et d'accessoires", family: "5 – Commerciale" },
	{ code: "561", label: "Vente au détail de vêtements et d'accessoires pour hommes", family: "5 – Commerciale" },
	{ code: "562", label: "Vente au détail de vêtements prêts-à-porter pour femmes", family: "5 – Commerciale" },
	{ code: "563", label: "Vente au détail de spécialités et d'accessoires pour femmes", family: "5 – Commerciale" },
	{ code: "564", label: "Vente au détail de lingerie d'enfants", family: "5 – Commerciale" },
	{ code: "565", label: "Vente au détail de vêtements", family: "5 – Commerciale" },
	{ code: "566", label: "Vente au détail de chaussures", family: "5 – Commerciale" },
	{ code: "567", label: "Vente au détail de complets sur mesure", family: "5 – Commerciale" },
	{ code: "568", label: "Vente au détail de vêtements de fourrure", family: "5 – Commerciale" },
	{
		code: "569",
		label: "Autres activités de vente au détail de vêtements et d'accessoires",
		family: "5 – Commerciale",
	},
	{ code: "57", label: "Vente au détail de mobiliers de maison et d'équipements connexes", family: "5 – Commerciale" },
	{
		code: "571",
		label: "Vente au détail de meubles, de mobiliers de maison et d'équipements",
		family: "5 – Commerciale",
	},
	{ code: "572", label: "Vente au détail d'appareils ménagers et d'aspirateurs", family: "5 – Commerciale" },
	{
		code: "573",
		label: "Vente au détail de radios, de téléviseurs, de systèmes de son et d'instruments de musique",
		family: "5 – Commerciale",
	},
	{ code: "574", label: "Vente au détail d'équipements et d'accessoires informatiques", family: "5 – Commerciale" },
	{ code: "58", label: "Hébergement et restauration", family: "5 – Commerciale" },
	{ code: "581", label: "Restauration avec service complet ou restreint", family: "5 – Commerciale" },
	{
		code: "582",
		label: "Établissement où l'on sert à boire (boissons alcoolisées) et activités diverses",
		family: "5 – Commerciale",
	},
	{ code: "583", label: "Établissement d'hébergement", family: "5 – Commerciale" },
	{ code: "589", label: "Autres activités spécialisées de restauration", family: "5 – Commerciale" },
	{ code: "59", label: "Autres activités de vente au détail", family: "5 – Commerciale" },
	{
		code: "591",
		label: "Vente au détail de médicaments, d'articles de soins personnels et d'appareils divers",
		family: "5 – Commerciale",
	},
	{
		code: "592",
		label: "Vente au détail de boissons alcoolisées et d'articles de fabrication",
		family: "5 – Commerciale",
	},
	{ code: "593", label: "Vente au détail d'antiquités et de marchandises d'occasion", family: "5 – Commerciale" },
	{
		code: "594",
		label: "Vente au détail de livres, de papeterie, de tableaux et de cadres",
		family: "5 – Commerciale",
	},
	{
		code: "595",
		label: "Vente au détail d'articles de sport, d'accessoires de chasse et pêche, de bicyclettes et de jouets",
		family: "5 – Commerciale",
	},
	{
		code: "596",
		label: "Vente au détail d'animaux de maison et d'activités reliées à la ferme",
		family: "5 – Commerciale",
	},
	{
		code: "597",
		label: "Vente au détail de bijoux, de pièces de monnaie et de timbres (collection)",
		family: "5 – Commerciale",
	},
	{ code: "598", label: "Vente au détail de combustibles", family: "5 – Commerciale" },
	{ code: "599", label: "Autres activités de la vente au détail", family: "5 – Commerciale" },
	{ code: "60", label: "Immeuble à bureaux", family: "6 – Services" },
	{ code: "61", label: "Finance, assurance et service immobilier", family: "6 – Services" },
	{ code: "611", label: "Banque et activité bancaire", family: "6 – Services" },
	{ code: "612", label: "Service de crédit (sauf les banques)", family: "6 – Services" },
	{
		code: "613",
		label: "Maison de courtiers et de négociants en valeurs mobilières et marchandes; bourse et activités connexes",
		family: "6 – Services",
	},
	{ code: "614", label: "Assurance, agent, courtier d'assurances et service", family: "6 – Services" },
	{ code: "615", label: "Immeuble et services connexes", family: "6 – Services" },
	{ code: "616", label: "Service de holding et d'investissement", family: "6 – Services" },
	{ code: "619", label: "Autres services immobiliers, financiers et d'assurance", family: "6 – Services" },
	{ code: "62", label: "Service personnel", family: "6 – Services" },
	{ code: "621", label: "Service de buanderie, de nettoyage à sec et de teinture", family: "6 – Services" },
	{ code: "622", label: "Service photographique (incluant les services commerciaux)", family: "6 – Services" },
	{ code: "623", label: "Salon de beauté, de coiffure et autres salons", family: "6 – Services" },
	{ code: "624", label: "Service funéraire, crématoire, cimetière et mausolée", family: "6 – Services" },
	{
		code: "625",
		label: "Service de réparation et de modification d'accessoires personnels et réparation de chaussures",
		family: "6 – Services",
	},
	{ code: "626", label: "Service pour les animaux domestiques", family: "6 – Services" },
	{ code: "629", label: "Autres services personnels", family: "6 – Services" },
	{ code: "63", label: "Service d'affaires", family: "6 – Services" },
	{ code: "631", label: "Service de publicité", family: "6 – Services" },
	{
		code: "632",
		label: "Bureau de crédit pour les commerces et les consommateurs et services de recouvrement",
		family: "6 – Services",
	},
	{ code: "633", label: "Service de soutien aux entreprises", family: "6 – Services" },
	{ code: "634", label: "Service pour les bâtiments et les édifices", family: "6 – Services" },
	{ code: "635", label: "Service de location (sauf entreposage)", family: "6 – Services" },
	{ code: "636", label: "Centre de recherche (sauf les centres d'essais)", family: "6 – Services" },
	{ code: "637", label: "Entreposage et service d'entreposage", family: "6 – Services" },
	{ code: "638", label: "Service de secrétariat, de traduction et de traitement de textes", family: "6 – Services" },
	{ code: "639", label: "Autres services d'affaires", family: "6 – Services" },
	{ code: "64", label: "Service de réparation", family: "6 – Services" },
	{ code: "641", label: "Service de réparation d'automobiles", family: "6 – Services" },
	{ code: "642", label: "Service de réparation de mobiliers, d'équipements et de machines", family: "6 – Services" },
	{ code: "643", label: "Service de réparation de véhicules légers", family: "6 – Services" },
	{ code: "644", label: "Service de réparation et d'entretien de véhicules lourds", family: "6 – Services" },
	{ code: "649", label: "Autres services de réparation et d'entretien", family: "6 – Services" },
	{ code: "65", label: "Service professionnel", family: "6 – Services" },
	{ code: "651", label: "Service médical et de santé", family: "6 – Services" },
	{ code: "652", label: "Service juridique", family: "6 – Services" },
	{ code: "653", label: "Service social", family: "6 – Services" },
	{ code: "654", label: "Service social hors institution", family: "6 – Services" },
	{ code: "655", label: "Service informatique", family: "6 – Services" },
	{ code: "656", label: "Service de soins paramédicaux", family: "6 – Services" },
	{ code: "657", label: "Service de soins thérapeutiques", family: "6 – Services" },
	{ code: "659", label: "Autres services professionnels", family: "6 – Services" },
	{ code: "66", label: "Service de construction", family: "6 – Services" },
	{ code: "661", label: "Service de construction et d'estimation de bâtiments en général", family: "6 – Services" },
	{ code: "662", label: "Service de construction (ouvrage de génie civil)", family: "6 – Services" },
	{ code: "663", label: "Service de travaux de finition de construction", family: "6 – Services" },
	{ code: "664", label: "Service de travaux spécialisés de construction", family: "6 – Services" },
	{ code: "665", label: "Service de travaux spécialisés en équipement technique", family: "6 – Services" },
	{ code: "67", label: "Service gouvernemental", family: "6 – Services" },
	{ code: "671", label: "Fonction exécutive, législative et judiciaire", family: "6 – Services" },
	{ code: "672", label: "Fonction préventive et activités connexes", family: "6 – Services" },
	{ code: "673", label: "Service postal", family: "6 – Services" },
	{ code: "674", label: "Établissement de détention et institution correctionnelle", family: "6 – Services" },
	{ code: "675", label: "Base et réserve militaire", family: "6 – Services" },
	{ code: "676", label: "Organisation internationale et autres organismes extraterritoriaux", family: "6 – Services" },
	{ code: "679", label: "Autres services gouvernementaux", family: "6 – Services" },
	{ code: "68", label: "Service éducationnel", family: "6 – Services" },
	{ code: "681", label: "École maternelle, enseignement primaire et secondaire", family: "6 – Services" },
	{ code: "682", label: "Université, école polyvalente, cégep", family: "6 – Services" },
	{ code: "683", label: "Formation spécialisée", family: "6 – Services" },
	{ code: "69", label: "Services divers", family: "6 – Services" },
	{ code: "691", label: "Activité religieuse", family: "6 – Services" },
	{ code: "692", label: "Fondations et organismes de charité", family: "6 – Services" },
	{ code: "693", label: "Service de récupération", family: "6 – Services" },
	{ code: "699", label: "Autres services divers", family: "6 – Services" },
	{ code: "71", label: "Exposition d'objets culturels", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "711", label: "Activité culturelle", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "712", label: "Exposition d'objets ou d'animaux", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "719", label: "Autres expositions d'objets culturels", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "72", label: "Rassemblement public", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "721", label: "Assemblée de loisirs", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "722", label: "Installation sportive", family: "7 – Culturelle, récréative et de loisirs" },
	{
		code: "723",
		label: "Aménagement public pour différentes activités",
		family: "7 – Culturelle, récréative et de loisirs",
	},
	{
		code: "729",
		label: "Autres aménagements d'assemblées publiques",
		family: "7 – Culturelle, récréative et de loisirs",
	},
	{ code: "73", label: "Amusement", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "731", label: "Parc d'exposition et parc d'amusement", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "739", label: "Autres lieux d'amusement", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "74", label: "Activité récréative", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "741", label: "Activité sportive", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "742", label: "Terrain de jeux et piste athlétique", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "743", label: "Natation", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "744", label: "Activité nautique", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "745", label: "Activité sur glace", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "748", label: "Activité de sport extrême", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "749", label: "Autres activités récréatives", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "75", label: "Centre touristique et camp de groupes", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "751", label: "Centre touristique", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "752", label: "Camp de groupes et camp organisé", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "76", label: "Parc", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "761", label: "Parc pour la récréation en général", family: "7 – Culturelle, récréative et de loisirs" },
	{
		code: "762",
		label: "Parc à caractère récréatif et ornemental",
		family: "7 – Culturelle, récréative et de loisirs",
	},
	{ code: "763", label: "Autres parcs et jardins", family: "7 – Culturelle, récréative et de loisirs" },
	{
		code: "79",
		label: "Jeux de hasard et autres activités culturelles",
		family: "7 – Culturelle, récréative et de loisirs",
	},
	{ code: "792", label: "Loterie et jeu de hasard", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "799", label: "Loisir et autres activités culturelles", family: "7 – Culturelle, récréative et de loisirs" },
	{ code: "81", label: "Agriculture", family: "8 – Production et extraction de richesses naturelles" },
	{ code: "812", label: "Production animale", family: "8 – Production et extraction de richesses naturelles" },
	{ code: "813", label: "Production végétale", family: "8 – Production et extraction de richesses naturelles" },
	{ code: "819", label: "Autres activités agricoles", family: "8 – Production et extraction de richesses naturelles" },
	{
		code: "82",
		label: "Activité reliée à l'agriculture",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "821",
		label: "Traitement relié à la production végétale",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "822",
		label: "Service relié à l'élevage d'animaux de ferme",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "829",
		label: "Autres activités reliées à l’agriculture",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "83",
		label: "Exploitation forestière et services connexes",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "831",
		label: "Foresterie et exploitation forestière",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "832",
		label: "Production de tourbe et de gazon",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "839",
		label: "Services reliés à la foresterie",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "84",
		label: "Pêche, chasse et activités connexes",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "841",
		label: "Pêcherie et produits de la mer",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{ code: "842", label: "Aquaculture animale", family: "8 – Production et extraction de richesses naturelles" },
	{
		code: "843",
		label: "Chasse et piégeage d'animaux à fourrure",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{ code: "844", label: "Reproduction du gibier", family: "8 – Production et extraction de richesses naturelles" },
	{
		code: "849",
		label: "Autres activités connexes à la pêcherie, à la chasse et au piégeage",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "85",
		label: "Exploitation minière et services connexes",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{ code: "851", label: "Extraction du minerai", family: "8 – Production et extraction de richesses naturelles" },
	{
		code: "852",
		label: "Exploitation minière du charbon",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "853",
		label: "Pétrole brut et gaz naturel (extraction)",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "854",
		label: "Extraction et travaux de carrière pour les minerais non métalliques (excluant le pétrole)",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "855",
		label: "Service professionnel minier",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "89",
		label: "Exploitation et extraction d'autres richesses naturelles",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "890",
		label: "Exploitation et extraction d’autres richesses naturelles",
		family: "8 – Production et extraction de richesses naturelles",
	},
	{
		code: "91",
		label: "Espace de terrain non aménagé et non exploité (excluant l'exploitation non commerciale de la forêt)",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "910",
		label: "Espace de terrain non aménagé et non exploité (excluant l’exploitation non commerciale de la forêt)",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "92",
		label: "Exploitation non commerciale de la forêt",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{ code: "921", label: "Service forestier non commercial", family: "9 – Immeubles non exploités et étendues d'eau" },
	{
		code: "922",
		label: "Forêt inexploitée qui n'est pas une réserve",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{ code: "93", label: "Étendue d'eau", family: "9 – Immeubles non exploités et étendues d'eau" },
	{ code: "931", label: "Rivière et ruisseau", family: "9 – Immeubles non exploités et étendues d'eau" },
	{ code: "932", label: "Lac", family: "9 – Immeubles non exploités et étendues d'eau" },
	{ code: "933", label: "Baie", family: "9 – Immeubles non exploités et étendues d'eau" },
	{ code: "934", label: "Mer et océan", family: "9 – Immeubles non exploités et étendues d'eau" },
	{ code: "939", label: "Autres étendues d’eau", family: "9 – Immeubles non exploités et étendues d'eau" },
	{ code: "94", label: "Espace de plancher inoccupé", family: "9 – Immeubles non exploités et étendues d'eau" },
	{
		code: "941",
		label: "Espace de plancher inoccupé dont l'usage serait résidentiel",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "942",
		label: "Espace de plancher inoccupé dont l’usage serait industriel",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "944",
		label: "Espace de plancher inoccupé dont l’usage serait pour services publics",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "945",
		label: "Espace de plancher inoccupé dont l’usage serait commercial",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "946",
		label: "Espace de plancher inoccupé dont l’usage serait pour des fins de services professionnels",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "947",
		label: "Espace de plancher inoccupé dont l’usage serait pour des fins culturelles",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "948",
		label: "Espace de plancher inoccupé dont l’usage serait pour des fins d’extraction de richesses naturelles",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "949",
		label: "Autres espaces de plancher inoccupé",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{ code: "95", label: "Immeuble en construction", family: "9 – Immeubles non exploités et étendues d'eau" },
	{
		code: "951",
		label: "Immeuble résidentiel en construction",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "952",
		label: "Immeuble non résidentiel en construction",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{ code: "953", label: "Immeuble incendié", family: "9 – Immeubles non exploités et étendues d'eau" },
	{
		code: "98",
		label: "Rubrique temporaire pour nouveaux usages",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "99",
		label: "Autres espaces de terrain et étendues d'eau inexploités",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
	{
		code: "990",
		label: "Autres espaces de terrain et étendues d’eau inexploités",
		family: "9 – Immeubles non exploités et étendues d'eau",
	},
]

export const propertyUseSelectOptions = propertyUseCategories.map(({ code, label, family }) => ({
	value: code,
	label: `${code} – ${label}`,
	group: family,
}))
